import {
  CliveAvatarIconError,
  CliveAvatarIconHappy,
  CliveAvatarIconLeft,
  CliveAvatarIconLoad,
  CliveAvatarIconRight,
} from '~/components/icons';
import CliveAvatarFrontIcon from '~/components/icons/clive/CliveAvatarFrontIcon';
import CliveAvatarSadFrontIcon from '~/components/icons/clive/CliveAvatarSadFrontIcon';

// Single source of truth for every Clive visual representation.
// Add new moods/assets here; call sites consume these maps (or the CliveAvatar
// component) instead of importing concrete icons/assets directly.

export const CLIVE_AVATARS = {
  left: CliveAvatarIconLeft,
  right: CliveAvatarIconRight,
  happy: CliveAvatarIconHappy,
  loading: CliveAvatarIconLoad,
  error: CliveAvatarIconError,
  sad: CliveAvatarSadFrontIcon,
  front: CliveAvatarFrontIcon,
  none: null,
} as const;

export type CliveMood = keyof typeof CLIVE_AVATARS;

// Named constants for the avatar moods so call sites reference CliveAvatar.MOOD.LOADING
// instead of raw string keys.
export const CLIVE_MOODS = {
  LEFT: 'left',
  RIGHT: 'right',
  HAPPY: 'happy',
  LOADING: 'loading',
  ERROR: 'error',
  SAD: 'sad',
  FRONT: 'front',
  NONE: 'none',
} as const satisfies Record<string, CliveMood>;

export const CLIVE_IMAGES = {
  full3d: 'bg-cliveFull3D',
  small: 'bg-cliveSmall',
  fab: 'bg-cliveFab',
} as const;

export const CLIVE_GRADIENTS = {
  pink: 'bg-clivePinkGradient',
  chip: 'bg-cliveChipGradient',
  dialog: 'bg-cliveDialogGradient',
  page: 'bg-clivePageGradient',
  light: 'bg-cliveLightGradiant',
  base: 'bg-cliveGradiant',
} as const;

export const CLIVE_VIBERANT_BORDER =
  'border-2 border-solid border-transparent [background:linear-gradient(#fff,#fff)_padding-box,theme(gradients.cliveViberant)_border-box]';
